import React from 'react';

const BackgroundShapes = () => {
  return (
    <div className="bg-shapes">
      <div className="bg-shape"></div>
      <div className="bg-shape"></div>
      <div className="bg-shape"></div>
    </div>
  );
};

export default BackgroundShapes;
